import React from 'react'
import { withTranslation } from 'react-i18next'
import { PageHeading } from '../components/Fragments'
import { useTranslation } from 'react-i18next';

const CURRENT_DATE = new Date();
const PRIMARY_ISSUE_OF_CURRENT_YEAR = CURRENT_DATE.getMonth() < 5;
const FIRST_ISSUE_OF_THE_YEAR_DEADLINE = CURRENT_DATE.getMonth() < 5 && new Date(Date.UTC(CURRENT_DATE.getFullYear(), 4, 1))
const SECOND_ISSUE_OF_THE_YEAR_DEADLINE = CURRENT_DATE.getMonth() >= 5 && new Date(Date.UTC(CURRENT_DATE.getFullYear(), 10, 1))

const ONGOING_CFP = {
  year: CURRENT_DATE.getFullYear(),
  issueNumber: PRIMARY_ISSUE_OF_CURRENT_YEAR ? 1 : 2,
  date: PRIMARY_ISSUE_OF_CURRENT_YEAR ? FIRST_ISSUE_OF_THE_YEAR_DEADLINE : SECOND_ISSUE_OF_THE_YEAR_DEADLINE
}


function CallForPapers({ t }) {
  const { i18n } = useTranslation();
  const { year, issueNumber, date } = ONGOING_CFP
  console.log({ year, issueNumber, date })
  return (
    <>
      <PageHeading pageTitle='menu.call_for_papers' acronym='acronym' researchCenter='cavas_research_center' />
      <p className="uk-text-lead">{t('pages.call_for_papers.part1')}</p>
      <p>{t('pages.call_for_papers.part2', { year, issueNumber, date: date.toLocaleDateString(i18n.language, { year: 'numeric', month: 'long', day: 'numeric' }) })}</p>
      <p>{t('pages.call_for_papers.part3')}</p>
    </>
  )
}

export default withTranslation()(CallForPapers)
